// src/pages/NotFound.jsx
import { Link, useLocation } from "react-router-dom";
import { useIntl } from 'react-intl'; // ✅ Adicionado
import LanguageSelector from "../components/LanguageSelector";

export default function NotFound() {
  const intl = useIntl();
  const { search } = useLocation();
  const currentLang = new URLSearchParams(search).get("lang") || "en";

  return (
      <div className="fullscreen-layout">
        <div className="left-panel">
          <div className="hero-panel">
            <img src="/lugarlogopw.png" alt="LugarAI Logo" />
          </div>
        </div>

        <div className="right-panel">
          <div style={{ position: "absolute", top: 20, right: 20 }}>
            <LanguageSelector />
          </div>

          <div className="auth-form">
            <h2>{intl.formatMessage({ id: "notFoundTitle" })}</h2>
            <p>{intl.formatMessage({ id: "notFoundText" })}</p>
            <Link
              to={`/?lang=${currentLang}`}
              style={{
                color: "#2563eb",
                textDecoration: "underline",
                marginTop: "1rem",
                display: "inline-block",
              }}
            >
              {intl.formatMessage({ id: "goHome" })}
            </Link>
          </div>
        </div>
      </div>
  );
}
